export default __webpack_public_path__ + "static/media/star-half.239a57e5.svg";